import { ConfigProvider } from "antd-mobile";
import { HashRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider, keepPreviousData } from "@tanstack/react-query";

import importCompont from "@/utlis/importCompont";
import useLocaleContext from "@/useLocaleContext";

import "./styles.less";

const Home = importCompont(() => import("./Router/Home"));
const Form = importCompont(() => import("./Router/Form"));

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            gcTime: 1000 * 60, // 数据垃圾回收时间 默认 1000 * 60 * 5 5分钟
            staleTime: 100 * 1, // 重新获取数据的时间间隔 默认0
            retry: 2, // 失败重试次数 默认 3次
            refetchOnWindowFocus: false, // 窗口获得焦点时重新获取数据
            placeholderData: keepPreviousData,
        },
    },
});

const Layouts = () => {
    return (
        <HashRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/form" element={<Form />} />
            </Routes>
        </HashRouter>
    );
};

const App = () => {
    const initValue = {
        token: localStorage.token,
        loading: true,
        refreshToken: 0,
    };
    return (
        <ConfigProvider>
            <QueryClientProvider client={queryClient}>
                <useLocaleContext.Provider value={initValue}>
                    <Layouts />
                </useLocaleContext.Provider>
            </QueryClientProvider>
        </ConfigProvider>
    );
};

export default App;
